/**
 * 读写localstorage的工具类
 */
const PREFIX_KEY = "YUNTOO_";

export const getLocalStorage = (key: string): string | null => {
  return localStorage.getItem(`${PREFIX_KEY}${key}`);
};

export const setLocalStorage = (key: string, value: string): void => {
  localStorage.setItem(`${PREFIX_KEY}${key}`, value);
};

export const removeLocalStorage = (key: string): void => {
  localStorage.removeItem(`${PREFIX_KEY}${key}`);
};

export const clearLocalStorage = (): void => {
  localStorage.clear();
};
